import { render, staticRenderFns } from "./Jobposition.vue?vue&type=template&id=f0748ef4&"
import script from "./Jobposition.vue?vue&type=script&lang=js&"
export * from "./Jobposition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports